import { PharmacySelect, PharmacyMetric } from './shared/PharmacyUI';
import React, { useState, useEffect, useRef } from 'react';
import { Box, Typography, CircularProgress, Tooltip, Dialog, Alert, useMediaQuery } from '@mui/material';


import { authService } from '../services/api';
import api from '../services/api';
import { IOS } from './shared/MenuLayout';

import { ProductHistoryChart, ProductFundingChart } from './shared/ProductCharts';
import './shared/Productos.css';

// ── Indicador config ──────────────────────────────────────────────────────────
const IND_CFG = {
  'SOBRESTOCK':   { bg:'#EDFAF2', border:'#B7EFD0', text:'#1A6B3C', dot:'#61AF95', accent:'#61AF95' },
  'NORMOSTOCK':   { bg:'#EDFAF2', border:'#B7EFD0', text:'#1A6B3C', dot:'#22C55E', accent:'#22C55E' },
  'SUBSTOCK':     { bg:'#FFF8E6', border:'#FFE9A0', text:'#8B6914', dot:'#DAAA70', accent:'#DAAA70' },
  'DESABASTECIDO':{ bg:'#FFF0EF', border:'#FFD4D1', text:'#C0392B', dot:'#DE8686', accent:'#DE8686' },
  'SIN ROTACION': { bg:'#F2F2F7', border:'#D1D1D6', text:'#636366', dot:'#8E8E93', accent:'#8E8E93' },
  'SIN CONSUMO':  { bg:'#F2F2F7', border:'#D1D1D6', text:'#636366', dot:'#8E8E93', accent:'#8E8E93' },
  'NO APLICA':    { bg:'#F0EFFF', border:'#C7C7F0', text:'#3730A3', dot:'#9388CC', accent:'#9388CC' },
};

const getInd = (val) => IND_CFG[val?.toUpperCase()] ||
  { bg:IOS.bg, border:IOS.separator, text:IOS.label2, dot:IOS.label3, accent:IOS.label2 };

// ── KPI Card ──────────────────────────────────────────────────────────────────
const KpiCard = PharmacyMetric;

// ── Indicador pill grande ─────────────────────────────────────────────────────
const IndicadorCard = ({ valor }) => {
  const cfg = getInd(valor);
  return (
    <Box className="pharmacy-layout products-indicator-card" sx={{ bgcolor:cfg.bg, borderRadius:'14px', p:2, border:`1px solid ${cfg.border}`,
      flex:'1 1 130px', minWidth:0, display:'flex', flexDirection:'column', justifyContent:'space-between',
      boxShadow:'0 1px 4px rgba(0,0,0,0.05)' }}>
      <Typography sx={{ fontSize: '0.72rem', fontWeight:700, color:cfg.text,
        letterSpacing:'0.07em', textTransform:'uppercase', opacity:0.7, mb:0.8 }}>Indicador</Typography>
      <Box className="pharmacy-layout" sx={{ display:'flex', alignItems:'center', gap:1 }}>
        <Box sx={{ width:10, height:10, borderRadius:'50%', bgcolor:cfg.dot, flexShrink:0 }} />
        <Typography sx={{ fontSize:'0.9rem', fontWeight:800, color:cfg.text, lineHeight:1.2 }}>
          {valor || 'N/A'}
        </Typography>
      </Box>
    </Box>
  );
};

// ══════════════════════════════════════════════════════════════════════════════
const FichaProductoModal = ({ codigo, nombre, onClose, onIpressChange }) => {
  const user  = authService.getCurrentUser();
  const ueId  = user?.ueIdEstablecimiento || user?.UeIdEstablecimiento || 0;

  const [kpis,    setKpis]    = useState(null);
  const [cols,    setCols]    = useState([]);
  const [stock,   setStock]   = useState(null);
  const [grafico, setGrafico] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error,setError]=useState(null);
  const [reload,setReload]=useState(0);
  const requestRef=useRef(0);
  const reduced=useMediaQuery('(prefers-reduced-motion: reduce)');
  const [tipoGraf, setTipoGraf] = useState('line');
  const [modoValor, setModoValor] = useState('cantidad'); // 'cantidad' | 'valorizado'
  const [fp, setFp] = useState(null);
  const [ipressList, setIpressList] = useState([]);
  const [ipressSel, setIpressSel] = useState('TODOS');

  useEffect(() => {
    if (!codigo) { setKpis(null); setStock(null); setGrafico(null); return; }
    if (ipressSel !== 'TODOS' && !ipressList.some(i=>i.nombre===ipressSel)) setIpressSel('TODOS');
    let active=true;
    const load = async () => {
      setLoading(true); setError(null);
      try {
        const periodo = new Date().getFullYear() +
          String(new Date().getMonth()+1).padStart(2,'0');

        const ipressActual = ipressList.find(i => i.nombre === ipressSel);
        const esTodos = ipressSel === 'TODOS' || !ipressActual;
        const entidadParams = esTodos
          ? { idEntidad: ueId, idUE: ueId, tipoEntidad: 'U' }
          : { idEntidad: ipressActual.idEstablecimiento, idUE: ueId, tipoEntidad: 'I' };
        onIpressChange && onIpressChange(esTodos ? null : ipressActual);

        const [rCols, rKpi, rStock, rGraf, rFp, rIpress] = await Promise.all([
          api.get(`/farmacia/productos/columnas?ueId=${ueId}`),
          api.get(`/farmacia/productos/${codigo}/ficha-detalle`,
            { params:{ codigoMed:codigo, idUnidadEjecutora:ueId, periodoRef:periodo } }),
          api.get('/farmacia/productos/stock-agrupado',
            { params:{ ueId, busqueda:codigo } }),
          api.get(`/farmacia/productos/${codigo}/ficha-historico`,
            { params:{ periodoRef:periodo, ...entidadParams, codigoMed:codigo } }),
          api.get(`/farmacia/productos/${codigo}/desagregado-fp`,
            { params:{ periodoRef:periodo, ...entidadParams, codigoMed:codigo } }),
          ipressList.length===0 ? api.get('/farmacia/productos/ipress-lista', { params:{ ueId } }) : Promise.resolve(null),
        ]);

        if(!active)return;
        if([rCols,rKpi,rStock,rGraf,rFp].some(r=>!r.data.success))throw new Error('Consulta incompleta');
        setStock(null);
        if (rCols.data.success)  setCols(rCols.data.data);
        if (rKpi.data.success)   setKpis(rKpi.data.data);
        if (rStock.data.success && rStock.data.data.length > 0) setStock(rStock.data.data[0]);
        if (rGraf.data.success)  setGrafico(rGraf.data.data);
        if (rFp.data.success)    setFp(rFp.data);
        if (rIpress?.data?.success) setIpressList(rIpress.data.data);
      } catch(e) { if(active)setError('No pudimos cargar la ficha. Inténtalo de nuevo.'); }
      finally { if(active)setLoading(false); }
    };
    load();
    return ()=>{active=false;};
  }, [codigo, ipressSel, reload]);

  const [drillDown, setDrillDown] = useState(null); // { periodo, periodoLabel, fuente, data, loading }
  const verDetalleIpress = async (periodoRaw, periodoLabel, fuente) => {
    const requestId=++requestRef.current;
    setDrillDown({ requestId, periodo:periodoRaw, periodoLabel, fuente, data:null, loading:true });
    try {
      const ipressActual = ipressList.find(i => i.nombre === ipressSel);
      const esTodos = ipressSel === 'TODOS' || !ipressActual;
      const entidadParams = esTodos
        ? { idEntidad: ueId, idUE: ueId, tipoEntidad: 'U' }
        : { idEntidad: ipressActual.idEstablecimiento, idUE: ueId, tipoEntidad: 'I' };
      const r = await api.get(`/farmacia/productos/${codigo}/desagregado-fp/detalle-ipress`,
        { params:{ periodo:periodoRaw, fuente, ...entidadParams, codigoMed:codigo } });
      if(!r.data.success)throw new Error('Consulta fallida');
      setDrillDown(prev => prev?.requestId===requestId?({ ...prev, data:r.data.data, loading:false }):prev);
    } catch(e) { console.error(e); setDrillDown(prev => prev?.requestId===requestId?({ ...prev, data:[], loading:false, error:true }):prev); }
  };

  const FP_COLOR = {
    'VENTA':'#61AF95',
    'SIS':'#669BDD',
    'ESSALUD':'#67B7B4',
    'INTERVENCION SANITARIA':'#9388CC',
    'DEFENSA NACIONAL':'#B68BCB',
    'EXONERADO':'#DAAA70',
    'SOAT':'#D5BD72',
    'CREDITO HOSPITALARIO':'#71ACCF',
    'OTROS CONVENIOS':'#D990B3',
    'VENTA INSTITUCIONAL':'#8D6E63',
    'DEVOLUCIONES':'#3A3A3C',
    'VENCIDO':'#DE8686',
    'MERMA':'#B8860B',
    'DISTRIBUCION':'#556B2F',
    'TRANSFERENCIA':'#4B0082',
    'OTRAS SALIDAS':'#8E8E93',
  };

  const esValorizado = modoValor === 'valorizado';

  return (
    <Box className="products-ficha">

      {/* ── Header ── */}
      <Box className="pharmacy-layout pharmacy-card products-ficha-heading" sx={{ display:'flex', alignItems:'flex-start', justifyContent:'space-between', gap:2, mb:2.5 }}>
        <Box sx={{ minWidth:0 }}>
          <Typography sx={{ fontSize: '0.72rem', fontWeight:700, color:IOS.label2,
            letterSpacing:'0.07em', textTransform:'uppercase', mb:0.3 }}>
            Ficha de Producto
          </Typography>
          <Typography sx={{ fontSize:'1.05rem', fontWeight:700, color:IOS.label,
            lineHeight:1.3, mb:0.3 }}>
            {nombre}
          </Typography>
          <Typography sx={{ fontSize:'0.72rem', color:IOS.label2, fontFamily:'ui-monospace,monospace' }}>
            {codigo}
          </Typography>
        </Box>
        {/* Volver */}
        <Box className="pharmacy-layout pharmacy-action" component="button" onClick={onClose}
          sx={{ height:36, px:1.6, borderRadius:'10px', border:`1px solid ${IOS.separator}`, flexShrink:0,
            bgcolor:IOS.surface, cursor:'pointer', display:'flex', alignItems:'center', gap:0.6,
            boxShadow:'0 1px 4px rgba(0,0,0,0.07)',
            transition:'all 0.15s', '&:hover':{ bgcolor:'#E5E5EA' } }}>
          <svg width="13" height="13" viewBox="0 0 24 24" fill="none"
            stroke={IOS.label} strokeWidth="2.3" strokeLinecap="round" strokeLinejoin="round">
            <path d="M19 12H5M12 19l-7-7 7-7"/>
          </svg>
          <Typography sx={{ fontSize:'0.78rem', fontWeight:600, color:IOS.label }}>Volver</Typography>
        </Box>
      </Box>

      {/* ── Contenido ── */}
      <Box>

        {loading && (
          <Box sx={{ py:10, textAlign:'center' }}>
            <CircularProgress sx={{ color:IOS.blue }} />
            <Typography sx={{ mt:1.5, color:IOS.label2, fontSize:'0.82rem' }}>Cargando ficha...</Typography>
          </Box>
        )}

        {error&&<Alert severity="error" action={<button className="products-text-button" onClick={()=>setReload(v=>v+1)}>Reintentar</button>}>{error}</Alert>}
        {!loading && !error && (
          <>
            {/* ── KPIs ── */}
            {kpis && (
              <Box className="pharmacy-layout" sx={{ display:'grid', gridTemplateColumns:{ xs:'1fr 1fr', sm:'repeat(auto-fit,minmax(130px,1fr))' }, gap:1.5, mb:2 }}>
                <KpiCard label="CPMA"
                  value={parseFloat(kpis.cpma||0).toLocaleString()}
                  accent={IOS.purple} />
                <KpiCard label="MSD"
                  value={parseFloat(kpis.msd||0).toFixed(2)}
                  accent={IOS.blue} />
                <KpiCard label="Req. 3 meses"
                  value={kpis.requerimiento3meses?.startsWith?.('-') ? '—'
                    : parseFloat(kpis.requerimiento3meses||0).toLocaleString()}
                  accent={IOS.orange} />
                <IndicadorCard valor={kpis.indicadorDigemid} />
              </Box>
            )}

            {/* ── Stock por almacén — misma fila de KPI que arriba ── */}
            {stock && cols.length > 0 && (
              <Box sx={{ mb:2 }}>
                <Typography sx={{ fontSize: '0.72rem', fontWeight:700, color:IOS.label2,
                  letterSpacing:'0.07em', textTransform:'uppercase', mb:1 }}>
                  Stock por Almacén
                </Typography>
                <Box className="pharmacy-layout" sx={{ display:'grid', gridTemplateColumns:{ xs:'1fr 1fr', sm:'repeat(auto-fit,minmax(130px,1fr))' }, gap:1.5 }}>
                  {cols.map((c,i) => (
                    <KpiCard key={i} label={c.nombre}
                      value={stock[c.columna] ? parseFloat(stock[c.columna]).toLocaleString() : '0'} />
                  ))}
                  {stock.PERIFERIA !== undefined && (
                    <KpiCard label="Periferia" value={parseFloat(stock.PERIFERIA||0).toLocaleString()} />
                  )}
                  <KpiCard label="Total" accent={IOS.blue}
                    value={(cols.reduce((s,c)=>s+parseFloat(stock[c.columna]||0),0)+parseFloat(stock.PERIFERIA||0)).toLocaleString()} />
                </Box>
              </Box>
            )}

            {/* ── Selector de IPRESS — afecta histórico y desglose por fuente ── */}
            {ipressList.length > 0 && (
              <Box className="pharmacy-layout" sx={{ display:'flex', alignItems:'center', gap:1, mb:2, flexWrap:'wrap' }}>
                <Typography sx={{ fontSize: '0.72rem', fontWeight:700, color:IOS.label2, letterSpacing:'0.05em', textTransform:'uppercase', width:{ xs:'100%', sm:'auto' } }}>IPRESS:</Typography>
                <PharmacySelect label="IPRESS del histórico" value={ipressSel} onChange={e=>setIpressSel(e.target.value)} w={320}>
                  <option value="TODOS">Todas las IPRESS</option>
                  {ipressList.filter(i=>i.nombre!=='TODOS').map(i=><option key={i.idEstablecimiento} value={i.nombre}>{i.nombre}</option>)}
                </PharmacySelect>
                <Typography sx={{ fontSize: '0.72rem', color:IOS.label3 }}>· afecta el histórico y el desglose por fuente</Typography>
              </Box>
            )}

            {/* ── Gráfico histórico ── */}
            <Box className="pharmacy-card products-chart-card" sx={{ bgcolor:IOS.surface, borderRadius:'14px', p:{ xs:1.8, sm:2.5 },
              boxShadow:'0 1px 4px rgba(0,0,0,0.07)', border:`1px solid ${IOS.separator}` }}>
              <Box className="pharmacy-layout" sx={{ display:'flex', alignItems:'flex-start', justifyContent:'space-between', mb:2, flexWrap:'wrap', gap:1.2 }}>
                <Box>
                  <Typography sx={{ fontSize: '0.72rem', fontWeight:700, color:IOS.label2,
                    letterSpacing:'0.07em', textTransform:'uppercase', mb:0.3 }}>
                    Histórico
                  </Typography>
                  <Typography sx={{ fontSize:'0.88rem', fontWeight:700, color:IOS.label }}>
                    Consumo y Stock
                  </Typography>
                </Box>
                <Box className="pharmacy-layout" sx={{ display:'flex', alignItems:'center', gap:1.5, flexWrap:'wrap', width:{ xs:'100%', sm:'auto' } }}>
                  <Box className="pharmacy-layout" sx={{ display:'flex', gap:2, flexWrap:'wrap' }}>
                    {[['Consumo', '#9C89C9'], ['Stock Final', '#61AF95']].map(([l,c]) => (
                      <Box className="pharmacy-layout" key={l} sx={{ display:'flex', alignItems:'center', gap:0.6 }}>
                        <Box sx={{ width:24, height:3, borderRadius:2, bgcolor:c }} />
                        <Typography sx={{ fontSize: '0.72rem', color:IOS.label2, fontWeight:500 }}>{l}</Typography>
                      </Box>
                    ))}
                  </Box>
                  <Box className="pharmacy-layout" sx={{ display:'flex', gap:0.3, bgcolor:IOS.bg, borderRadius:'10px', p:0.4 }}>
                    {[['cantidad','Cantidad'],['valorizado','Valorizado']].map(([key,lbl])=>(
                      <Box component="button" className="products-segment" aria-pressed={modoValor===key} key={key} onClick={()=>setModoValor(key)}
                        sx={{ px:1.1, py:0.5, borderRadius:'8px', cursor:'pointer', transition:'all 0.15s',
                          bgcolor:modoValor===key?IOS.surface:'transparent',
                          boxShadow:modoValor===key?'0 1px 3px rgba(0,0,0,0.12)':'none' }}>
                        <Typography sx={{ fontSize: '0.72rem', fontWeight:modoValor===key?700:500, color:modoValor===key?IOS.blue:IOS.label2 }}>{lbl}</Typography>
                      </Box>
                    ))}
                  </Box>
                  <Box className="pharmacy-layout" sx={{ display:'flex', gap:0.4, bgcolor:IOS.bg, borderRadius:'10px', p:0.4 }}>
                    {[
                      {key:'line', icon:<path d="M3 17l4-8 4 4 4-6 4 3" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" fill="none"/>},
                      {key:'bar',  icon:<><rect x="3" y="10" width="4" height="8" rx="1" fill="currentColor" opacity=".9"/><rect x="10" y="6" width="4" height="12" rx="1" fill="currentColor" opacity=".9"/><rect x="17" y="3" width="4" height="15" rx="1" fill="currentColor" opacity=".9"/></>},
                    ].map(({key,icon})=>(
                      <Tooltip key={key} title={key==='line'?'Línea':'Barras'} placement="top">
                        <Box component="button" className="pharmacy-layout products-segment" aria-label={key==='line'?'Gráfico de líneas':'Gráfico de barras'} aria-pressed={tipoGraf===key} onClick={()=>setTipoGraf(key)}
                          sx={{width:28,height:28,borderRadius:'8px',cursor:'pointer',display:'flex',alignItems:'center',justifyContent:'center',transition:'all 0.15s',
                            bgcolor:tipoGraf===key?IOS.surface:'transparent',
                            boxShadow:tipoGraf===key?'0 1px 3px rgba(0,0,0,0.12)':'none',
                            color:tipoGraf===key?IOS.blue:IOS.label2}}>
                          <svg width="16" height="16" viewBox="0 0 24 24">{icon}</svg>
                        </Box>
                      </Tooltip>
                    ))}
                  </Box>
                </Box>
              </Box>

              {grafico?.periodos?.length > 0 ? (
                <ProductHistoryChart grafico={grafico} mode={modoValor} type={tipoGraf}/>
              ) : (
                <Box className="pharmacy-layout" sx={{ height:{ xs:180, sm:240 }, display:'flex', flexDirection:'column',
                  alignItems:'center', justifyContent:'center', bgcolor:IOS.bg, borderRadius:'10px' }}>
                  <svg width="32" height="32" viewBox="0 0 24 24" fill="none"
                    stroke={IOS.label3} strokeWidth="1.5" strokeLinecap="round">
                    <path d="M3 3v18h18"/><path d="M18 9l-6 6-2-2-4 4"/>
                  </svg>
                  <Typography sx={{ mt:1.5, color:IOS.label3, fontSize:'0.82rem' }}>
                    Sin datos históricos
                  </Typography>
                </Box>
              )}
            </Box>

            {/* ── Desglose por fuente de financiamiento ── */}
            <Box className="pharmacy-card products-chart-card" sx={{ bgcolor:IOS.surface, borderRadius:'14px', p:{ xs:1.8, sm:2.5 }, mt:2,
              boxShadow:'0 1px 4px rgba(0,0,0,0.07)', border:`1px solid ${IOS.separator}` }}>
              <Box className="pharmacy-layout" sx={{ display:'flex', alignItems:'center', justifyContent:'space-between', mb:2, flexWrap:'wrap', gap:1 }}>
                <Box>
                  <Typography sx={{ fontSize: '0.72rem', fontWeight:700, color:IOS.label2,
                    letterSpacing:'0.07em', textTransform:'uppercase', mb:0.3 }}>
                    Últimos 12 meses · {esValorizado?'Valorizado (S/)':'Cantidad (unid.)'}
                  </Typography>
                  <Typography sx={{ fontSize:'0.88rem', fontWeight:700, color:IOS.label }}>
                    Consumo por Fuente de Financiamiento
                  </Typography>
                </Box>
              </Box>

              {loading ? null : !fp?.totalGeneral?.cantidad ? (
                <Box sx={{ py:5, textAlign:'center' }}>
                  <Typography sx={{ color:IOS.label3, fontSize:'0.82rem' }}>Sin movimientos en el período</Typography>
                </Box>
              ) : (() => {
                const fuentesActivas = fp.fuentes.filter(f => fp.totalesPorFuente[f]?.cantidad > 0);

                return (
                  <>
                    {/* Leyenda */}
                    <Box className="pharmacy-layout" sx={{ display:'flex', gap:1.2, flexWrap:'wrap', mb:1.5 }}>
                      {fuentesActivas.map(f => (
                        <Box className="pharmacy-layout" key={f} sx={{ display:'flex', alignItems:'center', gap:0.5 }}>
                          <Box sx={{ width:8, height:8, borderRadius:'2px', bgcolor:FP_COLOR[f]||IOS.label2, flexShrink:0 }} />
                          <Typography sx={{ fontSize: '0.72rem', color:IOS.label2 }}>{f}</Typography>
                        </Box>
                      ))}
                    </Box>

                    {/* Gráfico apilado */}
                    <ProductFundingChart fp={fp} sources={fuentesActivas} colors={FP_COLOR} mode={modoValor}/>

                    {/* Tabla detallada — período x fuente, scroll horizontal */}
                    <Box className="products-funding-table" tabIndex={0} role="region" aria-label="Consumo mensual por fuente, desplazamiento horizontal" sx={{ overflowX:'auto', WebkitOverflowScrolling:'touch', border:`1px solid ${IOS.separator}`, borderRadius:'10px',
                      '&::-webkit-scrollbar':{ height:5 }, '&::-webkit-scrollbar-thumb':{ bgcolor:IOS.separator, borderRadius:4 } }}>
                      <table style={{ width:'100%', borderCollapse:'collapse', fontSize:'0.7rem', minWidth:150+fuentesActivas.length*110 }}>
                        <thead>
                          <tr>
                            <th style={{ position:'sticky', left:0, zIndex:2, padding:'8px 10px', textAlign:'left',
                              fontSize: '0.72rem', fontWeight:700, color:IOS.label2, letterSpacing:'0.05em', textTransform:'uppercase',
                              bgcolor:IOS.surface, backgroundColor:IOS.surface, borderBottom:`1px solid ${IOS.separator}`, borderRight:`1px solid ${IOS.separator}` }}>
                              Período
                            </th>
                            {fuentesActivas.map(f => (
                              <th key={f} colSpan={2} style={{ padding:'8px 10px', textAlign:'center',
                                fontSize: '0.72rem', fontWeight:700, color:IOS.label2, letterSpacing:'0.04em', textTransform:'uppercase',
                                backgroundColor:IOS.surface, borderBottom:`1px solid ${IOS.separator}`, whiteSpace:'nowrap' }}>
                                <Box sx={{ display:'inline-flex', alignItems:'center', gap:0.5 }}>
                                  <Box sx={{ width:6, height:6, borderRadius:'2px', bgcolor:FP_COLOR[f]||IOS.label2 }} />
                                  {f}
                                </Box>
                              </th>
                            ))}
                            <th style={{ padding:'8px 10px', textAlign:'right', fontSize: '0.72rem', fontWeight:700, color:IOS.label,
                              letterSpacing:'0.05em', textTransform:'uppercase', backgroundColor:IOS.surface,
                              borderBottom:`1px solid ${IOS.separator}`, whiteSpace:'nowrap' }}>Total Cant.</th>
                            <th style={{ padding:'8px 10px', textAlign:'right', fontSize: '0.72rem', fontWeight:700, color:IOS.blue,
                              letterSpacing:'0.05em', textTransform:'uppercase', backgroundColor:IOS.surface,
                              borderBottom:`1px solid ${IOS.separator}`, whiteSpace:'nowrap' }}>Total S/</th>
                          </tr>
                          <tr>
                            <th style={{ position:'sticky', left:0, zIndex:2, backgroundColor:IOS.surface,
                              borderRight:`1px solid ${IOS.separator}`, borderBottom:`1px solid ${IOS.separator}` }} />
                            {fuentesActivas.map(f => (
                              <React.Fragment key={f}>
                                <th style={{ padding:'4px 6px', fontSize: '0.72rem', fontWeight:600, color:IOS.label3, borderBottom:`1px solid ${IOS.separator}` }}>Cant.</th>
                                <th style={{ padding:'4px 6px', fontSize: '0.72rem', fontWeight:600, color:IOS.label3, borderBottom:`1px solid ${IOS.separator}` }}>S/</th>
                              </React.Fragment>
                            ))}
                            <th colSpan={2} style={{ borderBottom:`1px solid ${IOS.separator}` }} />
                          </tr>
                        </thead>
                        <tbody>
                          {fp.periodosRaw.map((p,i) => (
                            <tr key={p} style={{ borderBottom:`1px solid ${IOS.separator}` }}>
                              <td style={{ position:'sticky', left:0, zIndex:1, padding:'7px 10px', fontWeight:600, color:IOS.label,
                                backgroundColor:IOS.surface, borderRight:`1px solid ${IOS.separator}`, whiteSpace:'nowrap' }}>
                                {fp.periodos[i]}
                              </td>
                              {fuentesActivas.map(f => {
                                const v = fp.matriz[p]?.[f] || { cantidad:0, valorizado:0 };
                                return (
                                  <React.Fragment key={f}>
                                    <td tabIndex={v.cantidad>0?0:undefined} role={v.cantidad>0?'button':undefined} aria-label={v.cantidad>0?`Ver ${f}, ${fp.periodos[i]}`:undefined} onKeyDown={e=>{if(v.cantidad>0&&(e.key==='Enter'||e.key===' ')){e.preventDefault();verDetalleIpress(p,fp.periodos[i],f);}}} onClick={()=>v.cantidad>0 && verDetalleIpress(p, fp.periodos[i], f)}
                                      style={{ padding:'7px 6px', textAlign:'right', color:v.cantidad>0?IOS.blue:IOS.label3, cursor:v.cantidad>0?'pointer':'default', textDecoration:v.cantidad>0?'underline':'none', textDecorationStyle:'dotted' }}>
                                      {v.cantidad>0?v.cantidad.toLocaleString():'—'}
                                    </td>
                                    <td tabIndex={v.cantidad>0?0:undefined} role={v.cantidad>0?'button':undefined} aria-label={v.cantidad>0?`Ver ${f}, ${fp.periodos[i]}`:undefined} onKeyDown={e=>{if(v.cantidad>0&&(e.key==='Enter'||e.key===' ')){e.preventDefault();verDetalleIpress(p,fp.periodos[i],f);}}} onClick={()=>v.cantidad>0 && verDetalleIpress(p, fp.periodos[i], f)}
                                      style={{ padding:'7px 6px', textAlign:'right', color:v.valorizado>0?IOS.label:IOS.label3, cursor:v.cantidad>0?'pointer':'default' }}>
                                      {v.valorizado>0?v.valorizado.toLocaleString(undefined,{minimumFractionDigits:2,maximumFractionDigits:2}):'—'}
                                    </td>
                                  </React.Fragment>
                                );
                              })}
                              <td style={{ padding:'7px 10px', textAlign:'right', fontWeight:700, color:IOS.label }}>
                                {(fp.totalesPorPeriodo[p]?.cantidad||0).toLocaleString()}
                              </td>
                              <td style={{ padding:'7px 10px', textAlign:'right', fontWeight:700, color:IOS.blue }}>
                                {(fp.totalesPorPeriodo[p]?.valorizado||0).toLocaleString(undefined,{minimumFractionDigits:2,maximumFractionDigits:2})}
                              </td>
                            </tr>
                          ))}
                        </tbody>
                        <tfoot>
                          <tr style={{ backgroundColor:IOS.bg }}>
                            <td style={{ position:'sticky', left:0, zIndex:1, padding:'8px 10px', fontWeight:800, color:IOS.label,
                              backgroundColor:IOS.bg, borderRight:`1px solid ${IOS.separator}` }}>TOTAL</td>
                            {fuentesActivas.map(f => {
                              const t = fp.totalesPorFuente[f] || { cantidad:0, valorizado:0 };
                              return (
                                <React.Fragment key={f}>
                                  <td style={{ padding:'8px 6px', textAlign:'right', fontWeight:700, color:IOS.label }}>{t.cantidad.toLocaleString()}</td>
                                  <td style={{ padding:'8px 6px', textAlign:'right', fontWeight:700, color:IOS.label }}>{t.valorizado.toLocaleString(undefined,{minimumFractionDigits:2,maximumFractionDigits:2})}</td>
                                </React.Fragment>
                              );
                            })}
                            <td style={{ padding:'8px 10px', textAlign:'right', fontWeight:800, color:IOS.label }}>
                              {fp.totalGeneral.cantidad.toLocaleString()}
                            </td>
                            <td style={{ padding:'8px 10px', textAlign:'right', fontWeight:800, color:IOS.blue }}>
                              {fp.totalGeneral.valorizado.toLocaleString(undefined,{minimumFractionDigits:2,maximumFractionDigits:2})}
                            </td>
                          </tr>
                        </tfoot>
                      </table>
                    </Box>
                  </>
                );
              })()}
            </Box>
          </>
        )}
      </Box>

      {drillDown && (() => {
        const colorFuente = FP_COLOR[drillDown.fuente] || IOS.label2;
        const totalCant = (drillDown.data||[]).reduce((s,d)=>s+d.cantidad,0);
        const totalVal = (drillDown.data||[]).reduce((s,d)=>s+d.valorizado,0);
        const maxCant = Math.max(...(drillDown.data||[]).map(d=>d.cantidad), 1);
        const RANK_COLORS = ['#648DB9','#839EBB','#A1B3C8'];
        return (
          <Dialog open onClose={()=>setDrillDown(null)} aria-labelledby="products-drill-title" fullWidth maxWidth="sm" transitionDuration={reduced?0:180}
            PaperProps={{className:'products-dialog',sx:{borderRadius:'24px',maxHeight:'85dvh',m:2,width:'calc(100% - 32px)'}}}>
            <Box className="pharmacy-modal-panel pharmacy-layout pharmacy-card" onClick={e=>e.stopPropagation()}
              sx={{ bgcolor:IOS.surface, borderRadius:'20px', overflow:'hidden', width:'100%', maxWidth:'100%',
                maxHeight:'78vh', display:'flex', flexDirection:'column', boxShadow:'0 24px 60px rgba(0,0,0,0.25)' }}>

              {/* Header */}
              <Box className="pharmacy-layout" sx={{ px:2.5, pt:2.5, pb:2, borderBottom:`1px solid ${IOS.separator}`,
                display:'flex', alignItems:'flex-start', justifyContent:'space-between', gap:1.5 }}>
                <Box className="pharmacy-layout" sx={{ display:'flex', gap:1.3, minWidth:0 }}>
                  <Box className="pharmacy-layout" sx={{ width:38, height:38, borderRadius:'11px', bgcolor:`${colorFuente}18`, flexShrink:0,
                    display:'flex', alignItems:'center', justifyContent:'center' }}>
                    <Box sx={{ width:10, height:10, borderRadius:'3px', bgcolor:colorFuente }} />
                  </Box>
                  <Box sx={{ minWidth:0 }}>
                    <Typography sx={{ fontSize: '0.72rem', fontWeight:700, color:IOS.label2, letterSpacing:'0.07em', textTransform:'uppercase', mb:0.2 }}>
                      Detalle por IPRESS
                    </Typography>
                    <Typography id="products-drill-title" sx={{ fontSize:'0.95rem', fontWeight:800, color:IOS.label, lineHeight:1.2 }}>{drillDown.fuente}</Typography>
                    <Typography sx={{ fontSize:'0.72rem', color:IOS.label2 }}>
                      {drillDown.periodoLabel} · {(drillDown.data||[]).length} establecimiento{(drillDown.data||[]).length!==1?'s':''}
                    </Typography>
                  </Box>
                </Box>
                <Box className="pharmacy-layout pharmacy-action" component="button" aria-label="Cerrar detalle por IPRESS" onClick={()=>setDrillDown(null)}
                  sx={{ width:28, height:28, borderRadius:'50%', border:'none', bgcolor:'#E5E5EA', cursor:'pointer', flexShrink:0,
                    display:'flex', alignItems:'center', justifyContent:'center', transition:'all 0.15s', '&:hover':{ bgcolor:'#D1D1D6' } }}>
                  <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke={IOS.label} strokeWidth="2.5" strokeLinecap="round"><path d="M18 6L6 18M6 6l12 12"/></svg>
                </Box>
              </Box>

              {/* Ranking */}
              <Box sx={{ p:2.2, overflowY:'auto', flex:1,
                '&::-webkit-scrollbar':{ width:4 }, '&::-webkit-scrollbar-thumb':{ bgcolor:IOS.separator, borderRadius:4 } }}>
                {drillDown.loading
                  ? <Box sx={{ py:5, textAlign:'center' }}><CircularProgress size={24} sx={{ color:colorFuente }} /></Box>
                  : drillDown.error ? <Alert severity="error">No pudimos consultar el detalle. Cierra e inténtalo de nuevo.</Alert> : !drillDown.data?.length
                    ? <Box sx={{ py:4, textAlign:'center' }}>
                        <Typography sx={{ color:IOS.label3, fontSize:'0.82rem' }}>Sin datos para este período</Typography>
                      </Box>
                    : <Box className="pharmacy-layout" sx={{ display:'flex', flexDirection:'column', gap:1.3 }}>
                        {drillDown.data.map((d,i) => (
                          <Box key={i}>
                            <Box className="pharmacy-layout" sx={{ display:'flex', alignItems:'center', gap:1, mb:0.5 }}>
                              <Box className="pharmacy-layout" sx={{ width:20, height:20, borderRadius:'50%', flexShrink:0,
                                bgcolor:i<3?RANK_COLORS[i]:IOS.bg, display:'flex', alignItems:'center', justifyContent:'center' }}>
                                <Typography sx={{ fontSize: '0.72rem', fontWeight:800, color:i<3?'white':IOS.label2 }}>{i+1}</Typography>
                              </Box>
                              <Typography sx={{ fontSize:'0.78rem', fontWeight:600, color:IOS.label, flex:1, minWidth:0,
                                overflow:'hidden', textOverflow:'ellipsis', whiteSpace:'nowrap' }}>
                                {d.establecimiento}
                              </Typography>
                              <Box sx={{ textAlign:'right', flexShrink:0 }}>
                                <Typography sx={{ fontSize:'0.8rem', fontWeight:800, color:IOS.label }}>{d.cantidad.toLocaleString()}</Typography>
                                <Typography sx={{ fontSize: '0.72rem', color:IOS.label2 }}>S/ {d.valorizado.toLocaleString(undefined,{minimumFractionDigits:2,maximumFractionDigits:2})}</Typography>
                              </Box>
                            </Box>
                            <Box sx={{ height:5, bgcolor:IOS.bg, borderRadius:4, overflow:'hidden', ml:3.6 }}>
                              <Box sx={{ width:`${(d.cantidad/maxCant)*100}%`, height:'100%', bgcolor:colorFuente, borderRadius:4, transition:'width 0.4s ease' }} />
                            </Box>
                          </Box>
                        ))}
                      </Box>
                }
              </Box>

              {/* Footer con total */}
              {!drillDown.loading && drillDown.data?.length > 0 && (
                <Box className="pharmacy-layout" sx={{ px:2.5, py:1.6, borderTop:`1px solid ${IOS.separator}`, bgcolor:IOS.bg,
                  display:'flex', justifyContent:'space-between', alignItems:'center' }}>
                  <Typography sx={{ fontSize: '0.72rem', fontWeight:700, color:IOS.label2, textTransform:'uppercase', letterSpacing:'0.05em' }}>Total</Typography>
                  <Box className="pharmacy-layout" sx={{ display:'flex', gap:1.5, alignItems:'baseline' }}>
                    <Typography sx={{ fontSize:'0.78rem', color:IOS.label2 }}>{totalCant.toLocaleString()} und.</Typography>
                    <Typography sx={{ fontSize:'0.9rem', fontWeight:800, color:colorFuente }}>
                      S/ {totalVal.toLocaleString(undefined,{minimumFractionDigits:2,maximumFractionDigits:2})}
                    </Typography>
                  </Box>
                </Box>
              )}
            </Box>
          </Dialog>
        );
      })()}
    </Box>
  );
};

export default FichaProductoModal;
